import { render, staticRenderFns } from "./PublicTournamentRegister.vue?vue&type=template&id=77140a10&scoped=true"
import script from "./PublicTournamentRegister.vue?vue&type=script&lang=js"
export * from "./PublicTournamentRegister.vue?vue&type=script&lang=js"
import style0 from "./PublicTournamentRegister.vue?vue&type=style&index=0&id=77140a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77140a10",
  null
  
)

export default component.exports